import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface ZoneOption {
    id: string;
    name: string;
}

export interface Zone extends ZoneOption {
    description: string;
    status: boolean;
    created_at: string;
    updated_at: string;
    pivot?: {
        region_id: string;
    }
}

export interface ZoneSingleResponse {
    data: Zone;
}

export interface StoreZoneRequest {
    name: string;
    description: string;
    status: boolean;
}

export function createZoneFormGroup(zone?: Zone) {
    return new FormGroup({
        name: new FormControl<string>(zone?.name ?? '', [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(255)
        ]),
        description: new FormControl<string>(zone?.description ?? '', [
            Validators.minLength(10),
            Validators.maxLength(500)
        ])
    });
}
